export interface TextRange {
  start: number;
  end: number;
}
